import { render, staticRenderFns } from "./funds.vue?vue&type=template&id=b28e09bc&scoped=true&"
import script from "./funds.vue?vue&type=script&lang=js&"
export * from "./funds.vue?vue&type=script&lang=js&"
import style0 from "./funds.vue?vue&type=style&index=0&id=b28e09bc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b28e09bc",
  null
  
)

export default component.exports